import { render, staticRenderFns } from "./Placements.vue?vue&type=template&id=49326126&scoped=true&"
import script from "./Placements.vue?vue&type=script&lang=js&"
export * from "./Placements.vue?vue&type=script&lang=js&"
import style0 from "./Placements.vue?vue&type=style&index=0&id=49326126&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49326126",
  null
  
)

export default component.exports